import { configureStore } from '@reduxjs/toolkit';
import sessionReducer from './store/sessionSlice';

const store = configureStore({
    reducer: {
        session: sessionReducer,
    },
});

export default store;
